module.exports = __webpack_public_path__ + "img/export-dates.a1517f06.png";